import { render, staticRenderFns } from "./TheError404View.vue?vue&type=template&id=70d88ff6&scoped=true"
import script from "./TheError404View.vue?vue&type=script&lang=js"
export * from "./TheError404View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d88ff6",
  null
  
)

export default component.exports